import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { GalaxyApi } from "@/api";
import { useFileSourceTemplatesStore } from "@/stores/fileSourceTemplatesStore";
import { rethrowSimple } from "@/utils/simple-error";
import InstanceDropdown from "@/components/ConfigTemplates/InstanceDropdown.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceDropdown',
    props: {
        fileSource: null
    },
    emits: ["entryRemoved", "test"],
    setup(__props, { emit }) {
        const props = __props;
        const fileSourceTemplatesStore = useFileSourceTemplatesStore();
        const routeEdit = computed(() => `/file_source_instances/${props.fileSource.uuid}/edit`);
        const routeUpgrade = computed(() => `/file_source_instances/${props.fileSource.uuid}/upgrade`);
        const isUpgradable = computed(() => fileSourceTemplatesStore.canUpgrade(props.fileSource.template_id, props.fileSource.template_version));
        async function onRemove() {
            const { error } = await GalaxyApi().PUT("/api/file_source_instances/{uuid}", {
                params: { path: { uuid: props.fileSource.uuid } },
                body: {
                    hidden: true,
                },
            });
            if (error) {
                rethrowSimple(error);
            }
            emit("entryRemoved");
        }
        return { __sfc: true, fileSourceTemplatesStore, props, routeEdit, routeUpgrade, isUpgradable, onRemove, emit, InstanceDropdown };
    }
});
